import React, { Fragment, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import AxisSpinner from "./AxisSpinner";
import { useAuth } from "../context/AuthContext";

export const TimesheetWeekTrustBreakDown = ({ timesheetWeek }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [overview, setOverview] = useState([]);

  useEffect(() => {
    getOverview();
  }, [timesheetWeek]);

  const getOverview = async () => {
    try {
      setLoading(true);

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {
          timesheet_week_id: timesheetWeek?.id,
        },
      };

      const response = await authAxios().get(
        "/api/backoffice/reporting/timesheet_week_overview_by_trust",
        config,
      );

      setOverview(response.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
  };

  const SpinnerOrData = (loading) => {
    if (loading) return <AxisSpinner loading={loading} />;
    return (
      <Card className="shadow-sm">
        <Card.Header className="bg-light">
          <h5 className="mb-0">
            <i className="fas fa-hospital me-2"></i>
            Trust Breakdown
          </h5>
        </Card.Header>
        <Card.Body className="p-0">
          <Table striped hover responsive className="mb-0">
            <thead>
              <tr>
                <th>Trust</th>
                <th>Missing</th>
                <th>Rejected</th>
                <th>Pending</th>
                <th>Approved</th>
              </tr>
            </thead>
            <tbody>
              {overview.length > 0 ? (
                overview.map((row, index) => (
                  <tr key={index}>
                    <td>{row?.trust}</td>
                    <td>{row?.missingTimesheets?.length}</td>
                    <td>{row?.rejectedTimesheets?.length}</td>
                    <td>{row?.pendingTimesheets?.length}</td>
                    <td>{row?.approvedTimesheets?.length}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-3 text-muted">
                    No trust data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    );
  };

  return <Fragment>{SpinnerOrData(loading)}</Fragment>;
};
